import { useSuspenseQuery } from '@tanstack/react-query';
import { isNil } from '../../../../../utils';
import { screensService } from '../../../../../api';
import { queryKey } from '../../../../../constant';

export const useAtomicProxyComponent = (url?: string) => {
  return useSuspenseQuery({
    // enabled: isNotNil(url),
    queryKey: queryKey.proxy(url),
    queryFn: () => {
      if (isNil(url)) return null;

      return screensService.getProxyComponents({ url });
    },
  });
};
